import React from 'react'
import { Header, Footer } from '../../containers/index'
import { Placeholder } from '../../components/index'

const Projects = () => {
  return (
    <div className="gradient__bg">
      <Header />
      <Placeholder />
      <Footer />
    </div>
  )
}

export default Projects
